import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { createFileRoute } from '@tanstack/react-router'
import { InvoiceForgivenessRequest } from 'features/billing'
import { canViewBillingPermission } from 'hooks/usePermission'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
)({
  component: RouteComponent,
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})

function RouteComponent() {
  const { invoiceId, subscriptionId } = Route.useParams()

  return <InvoiceForgivenessRequest invoiceId={invoiceId} subscriptionId={subscriptionId} />
}
